import React, { Component } from 'react';
import annotator from 'annotator';
import PropTypes from 'prop-types';

import './gengo-annotator.css';
import AnnotatorModule from '../../../lib/review-annotator/module';
import AnnotationService from '../../../services/Annotation';


class Target extends Component {
  constructor(props) {
    super(props);
    this.startAnnotator = this.startAnnotator.bind(this);
  }

  startAnnotator(uuid, editable, gocheckVersion) {
    const app = new annotator.App();
    const { onAnnotationChange } = this.props;
    const annotatorModule = new AnnotatorModule(
      app, this.refs.content, uuid, gocheckVersion, editable, onAnnotationChange,
    );
    app.include(() => annotatorModule);
    app.start().then(
      async () => {
        const annotations = await AnnotationService.getAnnotations(uuid);
        app.runHook('annotationsLoaded', [annotations]);
      },
    );
  }

  render() {
    const { review: { target } } = this.props;
    return (
      <section className="work-area fix-url-wrapping">
        <article>
          <div className="translated_content">
            <div id="content" ref="content">
              <p dir="auto">{target}</p>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

Target.propTypes = {
  review: PropTypes.object.isRequired,
  onAnnotationChange: PropTypes.func.isRequired,
};

export default Target;
